export const I18N_KEY = {
  stages: 'stages',
  years: 'years',
  months: 'months',
  days: 'days',
  hours: 'hours',
  minutes: 'minutes',
  seconds: 'seconds',
  newWord: 'newWord',
  works: 'works',
  members: 'members',
  money: 'money',
  requests: 'requests',
  events: 'events',
  voteWorkScore: 'voteWorkScore',
  voteResultScore: 'voteResultScore',
  requestsScore: 'requestsScore',
  userEventLanding: 'user_event_landing',
  eventData: 'event_data',
  notifications: 'notifications',
  nomination: 'nomination',
  category: 'category',
  question: 'question',
  value: 'value',
};
